module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Temperture/Tokyo_Temperture_GFDL_RCP45_Mid.png";